<template>
    <div class="scenes-column-wrapper">
        <div class="scenes-txt" v-if="row.addData.gameId && !isCurrentGame">
            {{ $t("zhiji.robotLog.from") }}:
            {{ getGameName(row.addData.gameId) }}
        </div>
        <div v-else>
            <p class="scenes-name">{{ firstScenes }}</p>
            <p class="scenes-name">
                <span v-show="showIcon">{{ scenesChart }}</span>
                {{ secondScenes }}
            </p>
        </div>
    </div>
</template>

<script>
import { isPubg } from "@/views/zhiji/js/lib/businessCheck.js";

export default {
    name: "ScenesColumn",
    props: ["data", "row"],
    data() {
        return {
            scenesChart: ">",
        };
    },
    computed: {
        showIcon() {
            let [firstScens, secondScens] = this.data;
            if (firstScens && secondScens) {
                return true;
            } else {
                return false;
            }
        },
        isCurrentGame() {
            const { gameId } = this.row.addData;
            const currentGameId = this.$store.state.zhiji.gameState.gameId;
            if (gameId == currentGameId) {
                return true;
            } else {
                return false;
            };
        },
        allGames() {
            const robots = this.$store.state.auth.businessSetting.robots || [];

            // pubg保持原来的逻辑不变
            if (isPubg()) {
                return [
                    {
                        value: 88888,
                        label: this.$t("zhiji.game.basicServices")
                    },
                    {
                        value: 80001,
                        label: this.$t("zhiji.game.securityBase")
                    },
                    {
                        value: 80002,
                        label: this.$t("zhiji.game.contentBase")
                    }
                ];
            }

            return robots.map(robot => {
                return {
                    value: robot.gameId,
                    label: robot.robotName
                };
            });
        },
        firstScenes() {
            if (this.data[0]) {
                return this.data[0].split("(")[0];
            } else {
                return "";
            }
        },
        secondScenes() {
            if (this.data[1]) {
                return this.data[1].split("(")[0];
            } else {;
                return "";
            }
        },
    },
    methods: {
        getGameName(gameId) {
            const gameInfo = this.allGames.filter(item => {
                return item.value == gameId;
            });
            if (gameInfo.length > 0) {
                return gameInfo[0].label;
            } else {
                return null;
            };
        }
    }
};
</script>

<style lang="less" scoped>
.scenes-column-wrapper {
    .scenes-txt {
        color: #7f7f7f;
    }
}
</style>